import { z } from 'zod';

export const PlanDetailSchema = z.object({
  difmCustomer: z.boolean(),
  inTrial: z.boolean(),
  inTrialEnd: z.boolean(),
  newbie: z.boolean(),
  partnerBilled: z.boolean(),
  partnerManaged: z.boolean(),
  pendingSuspend: z.boolean(),
  phoneNumber: z.string(),
  planGroupDescription: z.string(),
  planGroupId: z.number(),
  planGroupVersion: z.number(),
  singleBilled: z.boolean(),
  status: z.string(), // Assuming "T" or other similar statuses are strings
  suspended: z.boolean(),
  trialExpirationDate: z
    .number()
    .transform((value) => new Date(value))
    .pipe(z.date()),
  upgradeAllowed: z.boolean(),
  planGroupSubType: z.string().optional(),
});

export const UserRoleSchema = z.number();

export const PartnerOwnerSummarySchema = z
  .object({
    billingType: z.string(),
    companyName: z.string(),
    creationDate: z.number(), // timestamp
    parentPartnerUID: z.number(),
    partnerContactEmail: z.string().email(),
    partnerCurrency: z.string(),
    partnerInquiryUID: z.number(),
    partnerLevel: z.string(),
    partnerLevelString: z.string(),
    partnerName: z.string(),
    partnerPhoneNumber: z.string(),
    partnerSiteURL: z.string().url(),
    partnerStatus: z.string(),
    partnerStatusString: z.string(),
    partnerType: z.string(),
    partnerTypeString: z.string(),
    partnerUID: z.number(),
    partnercontactName: z.string(),
    soLoginUID: z.number(),
  })
  .nullable();

export type PlanDetail = z.infer<typeof PlanDetailSchema>;

export type UserRole = z.infer<typeof UserRoleSchema>;

export type PartnerOwnerSummary = z.infer<typeof PartnerOwnerSummarySchema>;
